import { apiRequest } from './apiClient';

export async function getStudentClasses() {
  const response = await apiRequest('/student/classes');

  return response.data || [];
}

export async function getStudentClassById(classId) {
  const response = await apiRequest(`/student/classes/${classId}`);

  return response.data || null;
}
